exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-text-banner[data-v-800c7a06]{position:relative;height:195px;background:url(" + require("images/banner/banner-1.jpg") + ") no-repeat 50%}.c-text-banner .text-area[data-v-800c7a06]{color:#fff;position:absolute;bottom:10px;left:20px;right:20px}.c-text-banner .text-area .title[data-v-800c7a06]{font-size:24px}.c-text-banner .text-area-left[data-v-800c7a06]{position:absolute;bottom:0;left:0}.c-text-banner .text-area-right[data-v-800c7a06]{max-width:700px;position:absolute;bottom:0;right:0;word-break:break-all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-800c7a06","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/textBanner.vue
// module id = 974
// module chunks = 23